import { controls,grouped } from "../controls";
const vendors = {
label: "Vendors",
pageLabel: "Vendors",starting: true,url: "autogen",
formActions: { edit: { allow: true },delete:{allow:true} },
pageType: "history",
formTabs:
 {allTabs: [
{ label: "General", uid: "general" },
{label: "Corrospondance Address",uid: "corrospondance_address"},
{label: "Company Details",uid: "company_details"},
{label: "Contact Details",uid: "contact_details"},
{label: "Holiday Details",uid: "holiday_details"},
{label: "Billing Account Details",uid: "billing_account_details"}
]},
filter:[
...controls.displayText({ tab: "filter", label: "Code"}),
...controls.text({ tab: "filter",  placeHolder: "", name: "vendor_code",maxlength:10}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "Description"}),
...controls.text({ tab: "filter",  placeHolder: "", name: "vendor_display",maxlength:50}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.checkBox({ tab: "filter",default:true, label: "Active", name: "vendor_active" }),
]
,form:[
...controls.displayText({ tab: "general", label: "Code",star:true}),
...controls.text({ tab: "general",  placeHolder: "", name: "vendor_code",isRequired:true,maxlength:10}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Description",star:true}),
...controls.text({ tab: "general",  placeHolder: "", name: "vendor_display",isRequired:true,maxlength:50}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.checkBox({ tab: "general", label: "Active",default:false, name: "vendor_active" }),
...controls.displayText({ tab: "corrospondance_address", label: "Line 1",star:false}),
...controls.text({ tab: "corrospondance_address",  placeHolder: "", name: "corrospondance_address.line_1",isRequired:false,width:"col-sm-4",maxlength:100}),
...controls.displayText({ tab: "corrospondance_address", label: "Line 2",star:false}),
...controls.text({ tab: "corrospondance_address",  placeHolder: "", name: "corrospondance_address.line_2",isRequired:false,width:"col-sm-4",maxlength:100}),
...controls.displayText({ tab: "corrospondance_address", label: "Line 3",star:false}),
...controls.text({ tab: "corrospondance_address",  placeHolder: "", name: "corrospondance_address.line_3",isRequired:false,width:"col-sm-4",maxlength:100}),
...controls.displayText({ tab: "corrospondance_address", label: "Village",star:true}),
...controls.oc({ tab: "corrospondance_address", c: "Village", placeHolder: "Village Code", name: "corrospondance_address.village_code", isRequired:true,fastpath:"villages"}),
...controls.showData({ tab: "corrospondance_address", displaytype: "capital", data: "corrospondance_address.village_display"}),
...controls.displayText({ tab: "corrospondance_address", label: "Taluka",star:true}),
...controls.oc({ tab: "corrospondance_address", c: "Taluka", placeHolder: "Taluka Code", name: "corrospondance_address.taluka_code", isRequired:true,fastpath:"talukas"}),
...controls.showData({ tab: "corrospondance_address", displaytype: "capital", data: "corrospondance_address.taluka_display"}),
...controls.displayText({ tab: "corrospondance_address", label: "District",star:true}),
...controls.oc({ tab: "corrospondance_address", c: "District", placeHolder: "District Code", name: "corrospondance_address.district_code", isRequired:true,fastpath:"districts"}),
...controls.showData({ tab: "corrospondance_address", displaytype: "capital", data: "corrospondance_address.district_display"}),
...controls.displayText({ tab: "corrospondance_address", label: "State",star:true}),
...controls.oc({ tab: "corrospondance_address", c: "State", placeHolder: "State Code", name: "corrospondance_address.state_code", isRequired:true,fastpath:"states"}),
...controls.showData({ tab: "corrospondance_address", displaytype: "capital", data: "corrospondance_address.state_display"}),
...controls.displayText({ tab: "corrospondance_address", label: "Country",star:true}),
...controls.oc({ tab: "corrospondance_address", c: "Country", placeHolder: "Country Code", name: "corrospondance_address.country_code", isRequired:true,fastpath:"countries"}),
...controls.showData({ tab: "corrospondance_address", displaytype: "capital", data: "corrospondance_address.country_display"}),
...controls.displayText({ tab: "corrospondance_address", label: "Pincode",star:false}),
...controls.text({ tab: "corrospondance_address",  placeHolder: "", name: "corrospondance_address.pincode",isRequired:false,maxlength:6}),
...controls.displayText({ tab: "corrospondance_address", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "company_details", label: "Full Name",star:true}),
...controls.text({ tab: "company_details",  placeHolder: "", name: "company_details.full_name",isRequired:true,width:"col-sm-4",maxlength:100}),
...controls.magicDateLabel({ tab: "company_details", label: "Date of Est.",target: "company_details.doi",star:true}),
...controls.magicDate({ tab: "company_details", name: "company_details.doi", dateType: "ontype",isRequired:true }),
...controls.displayText({ tab: "company_details", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "company_details", label: "TAN",star:true}),
...controls.tanNumber({ tab: "company_details",  placeHolder: "", name: "company_details.tan",isRequired:true,maxlength:10}),
...controls.displayText({ tab: "company_details", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "company_details", label: "GSTIN",star:false}),
...controls.gstinNumber({ tab: "company_details",  placeHolder: "", name: "company_details.gstin",isRequired:false,maxlength:15}),
...controls.displayText({ tab: "company_details", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "company_details", label: "Industry Type",star:false}),
...controls.oc({ tab: "company_details", c: "IndustryType", placeHolder: "Industry Type Code", name: "company_details.industry_type_code", isRequired:false,fastpath:"industry_types",autoopen:true}),
...controls.showData({ tab: "company_details", displaytype: "capital", data: "company_details.industry_type_display"}),
...controls.displayText({ tab: "company_details", label: "Udyam Aadhaar",star:false}),
...controls.text({ tab: "company_details",  placeHolder: "", name: "company_details.udyam_aadhaar",isRequired:false,maxlength:15}),
...controls.displayText({ tab: "company_details", label: "",width:"col-sm-2"}),
{
widths: "col-sm-12",
tab: "company_details",
title: "Ho Address",
subComponents: [
...controls.displayText({ tab: "company_details", label: "Line 1",star:false}),
...controls.text({ tab: "company_details",  placeHolder: "", name: "company_details.ho_address.line_1",isRequired:false,width:"col-sm-4",maxlength:100}),
...controls.displayText({ tab: "company_details", label: "Line 2",star:false}),
...controls.text({ tab: "company_details",  placeHolder: "", name: "company_details.ho_address.line_2",isRequired:false,width:"col-sm-4",maxlength:100}),
...controls.displayText({ tab: "company_details", label: "Line 3",star:false}),
...controls.text({ tab: "company_details",  placeHolder: "", name: "company_details.ho_address.line_3",isRequired:false,width:"col-sm-4",maxlength:100}),
...controls.displayText({ tab: "company_details", label: "Village",star:true}),
...controls.oc({ tab: "company_details", c: "Village", placeHolder: "Village Code", name: "company_details.ho_address.village_code", isRequired:true,fastpath:"villages"}),
...controls.showData({ tab: "company_details", displaytype: "capital", data: "company_details.ho_address.village_display"}),
...controls.displayText({ tab: "company_details", label: "Taluka",star:true}),
...controls.oc({ tab: "company_details", c: "Taluka", placeHolder: "Taluka Code", name: "company_details.ho_address.taluka_code", isRequired:true,fastpath:"talukas"}),
...controls.showData({ tab: "company_details", displaytype: "capital", data: "company_details.ho_address.taluka_display"}),
...controls.displayText({ tab: "company_details", label: "District",star:true}),
...controls.oc({ tab: "company_details", c: "District", placeHolder: "District Code", name: "company_details.ho_address.district_code", isRequired:true,fastpath:"districts"}),
...controls.showData({ tab: "company_details", displaytype: "capital", data: "company_details.ho_address.district_display"}),
...controls.displayText({ tab: "company_details", label: "State",star:true}),
...controls.oc({ tab: "company_details", c: "State", placeHolder: "State Code", name: "company_details.ho_address.state_code", isRequired:true,fastpath:"states"}),
...controls.showData({ tab: "company_details", displaytype: "capital", data: "company_details.ho_address.state_display"}),
...controls.displayText({ tab: "company_details", label: "Country",star:true}),
...controls.oc({ tab: "company_details", c: "Country", placeHolder: "Country Code", name: "company_details.ho_address.country_code", isRequired:true,fastpath:"countries"}),
...controls.showData({ tab: "company_details", displaytype: "capital", data: "company_details.ho_address.country_display"}),
...controls.displayText({ tab: "company_details", label: "Pincode",star:false}),
...controls.text({ tab: "company_details",  placeHolder: "", name: "company_details.ho_address.pincode",isRequired:false,maxlength:6}),
...controls.displayText({ tab: "company_details", label: "",width:"col-sm-2"}),
]},
...controls.displayText({ tab: "contact_details", label: "Full Name",star:false}),
...controls.text({ tab: "contact_details",  placeHolder: "", name: "full_name",isRequired:false,width:"col-sm-4",maxlength:100}),
...controls.displayText({ tab: "contact_details", label: "Contact Number",star:false}),
...controls.text({ tab: "contact_details",  placeHolder: "", name: "contact_number",isRequired:false,maxlength:20}),
...controls.displayText({ tab: "contact_details", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "contact_details", label: "Email Address",star:false}),
...controls.text({ tab: "contact_details",  placeHolder: "", name: "email_address",isRequired:false,width:"col-sm-4",maxlength:100}),
...controls.displayText({ tab: "contact_details", label: "Fax Number",star:false}),
...controls.text({ tab: "contact_details",  placeHolder: "", name: "fax_number",isRequired:false,maxlength:50}),
...controls.displayText({ tab: "contact_details", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "contact_details", label: "Whats App Number",star:false}),
...controls.text({ tab: "contact_details",  placeHolder: "", name: "whats_app_number",isRequired:false,maxlength:20}),
...controls.displayText({ tab: "contact_details", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "contact_details", label: "Designation",star:false}),
...controls.oc({ tab: "contact_details", c: "Designation", placeHolder: "Designation Code", name: "designation_code", isRequired:false,fastpath:"designations"}),
...controls.showData({ tab: "contact_details", displaytype: "capital", data: "designation_display"}),

...controls.displayText({ tab:"contact_details" ,width:"col-sm-12", label: "" }),
...controls.displayText({ tab:"contact_details" ,width:"col-sm-4", label: "" }),
...controls.button({
tab:"contact_details",
 label: "ADD",
 style: { padding: 0 },
Bcolor: "success",
 onclick: {
  action: "appendToHTMLTable",
  tableNameField: "contact_details",
  requiredField: ["full_name","contact_number","email_address","fax_number","whats_app_number","designation_code","designation_display","designation_uid",]
}, width: "col-sm-2"
}),
...controls.button({
tab:"contact_details",
 label: "CLEAR",
 style: { padding: 0 },
Bcolor: "warning",
 onclick: {
  action: "clearForm",
  tableNameField: "contact_details",
  requiredField: ["full_name","contact_number","email_address","fax_number","whats_app_number","designation_code","designation_display","designation_uid",]
}, width: "col-sm-2"
}),
{
  tab:"contact_details",
inputType: "table",
  tableTitle: "",
  deletable: true,
  editable: true,
  tableHeaders: [
    { label: "Sr", type: "autoinc" },
    { label: "Full Name", field: "full_name"},
    { label: "Contact Number", field: "contact_number"},
    { label: "Email Address", field: "email_address"},
    { label: "Fax Number", field: "fax_number"},
    { label: "Whats App Number", field: "whats_app_number"},
    { label: "Designation Code", field: "designation_code"},
    { label: "Designation Display", field: "designation_display"},
  ],
  widths: {
    parent: "col-sm-12",
    children: "col-sm-12"
  },
  name: "contact_details"
},
...controls.displayText({ tab: "holiday_details", label: "Dow",star:false}),
...controls.oc({ tab: "holiday_details", c: "DOW", placeHolder: "Dow Code", name: "dow_code", isRequired:false,fastpath:"dows",autoopen:true}),
...controls.showData({ tab: "holiday_details", displaytype: "capital", data: "dow_display"}),
...controls.magicDateLabel({ tab: "holiday_details", label: "Holiday Date",target: "holiday_date",star:false}),
...controls.magicDate({ tab: "holiday_details", name: "holiday_date", dateType: "ontype",isRequired:false }),
...controls.displayText({ tab: "holiday_details", label: "",width:"col-sm-2"}),

...controls.displayText({ tab:"holiday_details" ,width:"col-sm-12", label: "" }),
...controls.displayText({ tab:"holiday_details" ,width:"col-sm-4", label: "" }),
...controls.button({
tab:"holiday_details",
 label: "ADD",
 style: { padding: 0 },
Bcolor: "success",
 onclick: {
  action: "appendToHTMLTable",
  tableNameField: "holiday_details",
  requiredField: ["dow_code","dow_display","dow_uid","holiday_date",]
}, width: "col-sm-2"
}),
...controls.button({
tab:"holiday_details",
 label: "CLEAR",
 style: { padding: 0 },
Bcolor: "warning",
 onclick: {
  action: "clearForm",
  tableNameField: "holiday_details",
  requiredField: ["dow_code","dow_display","dow_uid","holiday_date",]
}, width: "col-sm-2"
}),
{
  tab:"holiday_details",
inputType: "table",
  tableTitle: "",
  deletable: true,
  editable: true,
  tableHeaders: [
    { label: "Sr", type: "autoinc" },
    { label: "Dow Code", field: "dow_code"},
    { label: "Dow Display", field: "dow_display"},
    { label: "Holiday Date", field: "holiday_date", displaytype: "date"},
  ],
  widths: {
    parent: "col-sm-12",
    children: "col-sm-12"
  },
  name: "holiday_details"
},
...controls.displayText({ tab: "billing_account_details", label: "Account Number",star:false}),
...controls.text({ tab: "billing_account_details",  placeHolder: "", name: "account_number",isRequired:false,maxlength:20}),
...controls.displayText({ tab: "billing_account_details", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "billing_account_details", label: "Ifsc Code",star:false}),
...controls.text({ tab: "billing_account_details",  placeHolder: "", name: "ifsc_code",isRequired:false,maxlength:11}),
...controls.displayText({ tab: "billing_account_details", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "billing_account_details", label: "Bank",star:false}),
...controls.oc({ tab: "billing_account_details", c: "Bank", placeHolder: "Bank Code", name: "bank_code", isRequired:false,fastpath:"banks"}),
...controls.showData({ tab: "billing_account_details", displaytype: "capital", data: "bank_display"}),
...controls.displayText({ tab: "billing_account_details", label: "Upi Address",star:false}),
...controls.text({ tab: "billing_account_details",  placeHolder: "", name: "upi_address",isRequired:false,width:"col-sm-4",maxlength:100 ,isReadOnly:"edit" }),

...controls.displayText({ tab:"billing_account_details" ,width:"col-sm-12", label: "" }),
...controls.displayText({ tab:"billing_account_details" ,width:"col-sm-4", label: "" }),
...controls.button({
tab:"billing_account_details",
 label: "ADD",
 style: { padding: 0 },
Bcolor: "success",
 onclick: {
  action: "appendToHTMLTable",
  tableNameField: "billing_account_details",
  requiredField: ["account_number","ifsc_code","bank_code","bank_display","bank_uid","upi_address",]
}, width: "col-sm-2"
}),
...controls.button({
tab:"billing_account_details",
 label: "CLEAR",
 style: { padding: 0 },
Bcolor: "warning",
 onclick: {
  action: "clearForm",
  tableNameField: "billing_account_details",
  requiredField: ["account_number","ifsc_code","bank_code","bank_display","bank_uid","upi_address",]
}, width: "col-sm-2"
}),
{
  tab:"billing_account_details",
inputType: "table",
  tableTitle: "",
  deletable: true,
  editable: true,
  tableHeaders: [
    { label: "Sr", type: "autoinc" },
    { label: "Account Number", field: "account_number"},
    { label: "Ifsc Code", field: "ifsc_code"},
    { label: "Bank Code", field: "bank_code"},
    { label: "Bank Display", field: "bank_display"},
    { label: "Upi Address", field: "upi_address"},
  ],
  widths: {
    parent: "col-sm-12",
    children: "col-sm-12"
  },
  name: "billing_account_details"
},
]
,history:{
perPage: 10,
reportHeader: "Vendors",
pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
clickable: true,
displayColumns: [
{Header: "Sr",type: "autoinc",accessor: "srno",align: "center",width: 30},
{Header: "Vendor Code",accessor: "vendor_code",},
{Header: "Vendor",accessor: "vendor_display",},
{Header: "Vendor Active",accessor: "vendor_active",type:'tick'},
]}};
export default vendors;